import moment from 'moment';

const work_time = {
    duty_type: {
        both: {id: 1, comment: '諮詢+探視', label: 'duty_type_1'},
        consult: {id: 2, comment: '諮詢', label: 'duty_type_2'},
    },
    status: {
        un_sign: {id: 1, name: '未排班', label: 'un_sign'},
        sign: {id: 2, name: '已排班', label: 'sign'},
        had_leave: {id: 3, name: '已排班已請假', label: 'had_leave'},
        add_work: {id: 4, name: '未排班多加班', label: 'add_work'}
    },
    weekday: {
        0: {id: 0, name: 'sunday'},
        1: {id: 1, name: 'monday'},
        2: {id: 2, name: 'tuesday'},
        3: {id: 3, name: 'wednesday'},
        4: {id: 4, name: 'thursday'},
        5: {id: 5, name: 'friday'},
        6: {id: 6, name: 'saturday'},
    }
};

export default {

    getUTCDate() {
        return moment.utc().toDate();
    },
    getTimezone(date) {
        // 參考資料 : https://stackoverflow.com/questions/34838542/how-to-get-timezone-offset-from-moment-object
        return moment.parseZone(date).utcOffset();
    },
    addOneHour(date) {
        if (typeof date === 'string') return moment(new Date(date)).add(1, 'h').utc().toDate();
        else if (date instanceof Date) return moment(date).add(1, 'h').utc().toDate();
        else return null;
    },
    addOneDay(date) {
        // 參考資料 : https://momentjs.com/docs/#/manipulating/add/
        return moment(date).add(1, 'days').utc().toDate();
    },
    addOneMonth(date) {
        return moment(date).add(1, 'months').utc().toDate();
    },
    addOneYear(date) {
        return moment(date).add(1, 'years').utc().toDate();
    },
    addTime({date, timeAmount, timeType}) {
        // 參考資料 : https://momentjs.com/docs/#/manipulating/add/
        if (typeof date === 'string') {
            return moment(new Date(date)).add(timeAmount, timeType).utc().toDate();
        } else if (date instanceof Date) {
            return moment(date).add(timeAmount, timeType).utc().toDate();
        } else {
            return;
        }
    },
    format({milliseconds, date, formatPattern = 'YYYY-MM-DD', timezone = 8}) {
        return moment(milliseconds || date).utcOffset(timezone).format(formatPattern);
    },
    formatTimeUsage(time_usage) {
        if (time_usage) return moment.utc(moment.duration(time_usage).asMilliseconds()).format("HH 小時 mm 分 ss 秒");
        else return null;
    },
    getDayTime({date, timezone = 8}) {
        return moment(date).utcOffset(timezone) - moment(date).utcOffset(timezone).startOf('day');
    },
    getTime(time = 0) {
        return moment.duration(time).asMilliseconds(); // 取得 duration , 將其轉換成 milliseconds
    },
    getTimeUsage({start_time, end_time}) {
        if (!start_time || !end_time) return 0;
        const timeUsageInMilliseconds = end_time - start_time;
        return (timeUsageInMilliseconds < 0) ? 0 : timeUsageInMilliseconds;
    },
    getCurrentMonth() {
        return this.format({milliseconds: new Date().getTime(), formatPattern: 'MM'});
    },
    getDateStartWithTimezone({date, timezone = 8}) {
        const momentObj = moment(date);
        momentObj.utcOffset(timezone);
        return momentObj.startOf('day').toDate(); // https://momentjs.com/docs/#/manipulating/start-of/
    },
    getWeekDay(date) {
        return moment(date).weekday();  // Number
    },
    getWeekDayStr(date) {
        return work_time.weekday[this.getWeekDay(date)].name;
    },
    getWeekDayFromName(name) {
        const weekdayObjs = Object.values(work_time.weekday);
        const targetWeekdayObj = weekdayObjs.find(function (weekdayObj) {
            return weekdayObj.name === name;
        });
        return targetWeekdayObj.id;
    },
    getTaiwanYear({date}) {
        let temp = moment(date);
        return temp.year() - 1911;
    },
    getYear({date}) {
        let temp = moment(date);
        return temp.year();
    },
    getMonth({date}) {
        let temp = moment(date);
        return temp.month();
    },
    isCloserThan24hr({startTime, endTime, date}) {
        const diff1 = this.getDateDiff({date1: startTime, date2: date});
        const diff2 = this.getDateDiff({date1: endTime, date2: date});
        const compare = Math.min(diff1, diff2);
        return compare <= 1000 * 60 * 60 * 24;
    },
    getWaitInMilliseconds({create_at, rematching_start_time}) {
        const now = new Date();
        const rst = rematching_start_time;
        const createAtDiff = this.getDateDiff({date2: now, date1: create_at});
        const rematchingStartTimeDiff = (rst && this.getDateDiff({date2: now, date1: rst})) || 0;
        return Math.max(createAtDiff, rematchingStartTimeDiff);
    },
    getDateDiff({date1, date2}) {
        const day1 = (typeof date1 === 'string') ? new Date(date1) : date1;
        const day2 = (typeof date2 === 'string') ? new Date(date2) : date2;
        const diffInMilliseconds = Math.abs(day1.getTime() - day2.getTime());
        return diffInMilliseconds;
    },
    getDateTimeWithTimezone({date, time, timezone = 8}) {
        // time = ''24:00:00' 會報錯
        time = (time === '24:00:00') ? '23:59:59.999' : time;
        return moment().utcOffset(timezone).set({
            year: moment(date).year(),
            month: moment(date).month(),
            date: moment(date).date(),
            hour: moment(time, "HH:mm:ss").utc().hour(),
            minute: moment(time, "HH:mm:ss").utc().minute(),
            second: moment(time, "HH:mm:ss").utc().second(),
            millisecond: moment(time, "HH:mm:ss").utc().millisecond()
        }).toDate();
    },
    getDateWithTimezone({timezone = 8}) {
        return moment().utcOffset(timezone).toDate();
    },
    getDateArray({startDate, endDate, weekdays, weekdayStrs, frequency}) {

        switch (frequency) {
            case 'day':
                return this.getDailyDateArray({startDate, endDate});
            case 'week':
                return this.getWeeklyDateArray({startDate, endDate, weekdays, weekdayStrs});
            case 'month':
                return this.getMonthlyDateArray({startDate, endDate});
            case 'year':
                return this.getYearlyDateArray({startDate, endDate});
            default:
                return [];
        }
    },
    getDailyDateArray({startDate, endDate}) {

        const newStartDate = moment(startDate).toDate();
        const newEndDate = moment(endDate).toDate();

        if (newEndDate < newStartDate) return [];
        const dateArray = [];
        let currentDate = newStartDate;
        while (currentDate <= newEndDate) {
            dateArray.push(currentDate);
            currentDate = this.addOneDay(currentDate);
        }
        return dateArray;
    },
    getWeeklyDateArray({startDate, endDate, weekdays, weekdayStrs}) {
        if (typeof endDate === 'string') endDate = new Date(endDate);
        if (typeof startDate === 'string') startDate = new Date(startDate);
        weekdays = (weekdays) ? weekdays : weekdayStrs && weekdayStrs.map((weekdayStr) => {
            return this.getWeekDayFromName(weekdayStr);
        });
        if (endDate < startDate) return [];
        const dateArray = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
            const currentDateWeekDay = this.getWeekDay(currentDate);
            if (weekdays.includes(currentDateWeekDay)) dateArray.push(currentDate);
            currentDate = this.addOneDay(currentDate);
        }
        return dateArray;
    },
    getMonthlyDateArray({startDate, endDate}) {
        if (typeof endDate === 'string') endDate = new Date(endDate);
        if (typeof startDate === 'string') startDate = new Date(startDate);
        if (endDate < startDate) return [];
        const dateArray = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
            dateArray.push(currentDate);
            currentDate = this.addOneMonth(currentDate);
        }
        return dateArray;
    },
    getYearlyDateArray({startDate, endDate}) {
        if (typeof endDate === 'string') endDate = new Date(endDate);
        if (typeof startDate === 'string') startDate = new Date(startDate);
        if (endDate < startDate) return [];
        const dateArray = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
            dateArray.push(currentDate);
            currentDate = this.addOneYear(currentDate);
        }
        return dateArray;
    },
    getEveryDateOfMonth({year, month, timezone = 8}) {
        const date = moment().utcOffset(timezone).set({year, month, date: 1,}).toDate();
        const startDate = this.getStartDateOfMonth({date, timezone});
        const endDate = this.getEndDateOfMonth({date, timezone});
        return this.getDailyDateArray({startDate, endDate});
    },
    getStartDateOfMonth({date, timezone = 8}) {
        const momentObj = moment(date);
        momentObj.utcOffset(timezone);
        return momentObj.startOf('month').toDate(); // https://momentjs.com/docs/#/manipulating/start-of/
    },
    getEndDateOfMonth({date, timezone = 8}) {
        const momentObj = moment(date);
        momentObj.utcOffset(timezone);
        return momentObj.endOf('month').toDate(); // https://momentjs.com/docs/#/manipulating/end-of/
    },
    getLastMonthDate(date) {
        return moment(date).subtract(1, 'month').toDate();
    }

};



// WEBPACK FOOTER //
// ./src/util/dateUtil.js